export default function mapStateToProps (state) {
  const { 
    pageTitle, 
    appState,
    wallet
  } = state;
  
  return { 
    pageTitle, 
    appState,
    wallet
  };
}